import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import QuizPage from '../../../pages/Cards/QuizPage';
import QuizMobile from '../../../pages/Mobile/Cards/QuizMobile';

const QuizResponsive: React.FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <QuizMobile /> : <QuizPage />;
};

export default QuizResponsive;
